/**
 * Anahtar (switch) — **parmak** mertebesi. Vuexy 10.11 `form-check form-switch` ölçüsü:
 * ray 2em × 1.2em (32×20px), radius 2em, seçiliyken zemin primary; topuz beyaz daire,
 * hafif gölge, 150ms kayar. Onay kutusu (checkbox) "Açık/Kapalı" gibi durum
 * ayarları için yanlış araçtır — ölçüldü: metin "Kapalı" yanında boş kutu, kullanıcı
 * ne olduğunu anlamıyordu.
 */

import type { InputHTMLAttributes } from 'react';
import { cn } from '../../lib/cn';

interface AnahtarProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'onChange'> {
  checked: boolean;
  onChange: (acik: boolean) => void;
  /** Anahtarın yanındaki durum metni ("Açık" / "Kapalı" ya da açıklayıcı cümle). */
  etiket?: string;
}

export function Anahtar({ checked, onChange, etiket, disabled, className, id, ...kalan }: AnahtarProps) {
  return (
    <label
      className={cn(
        'inline-flex items-center gap-2 py-1.5',
        disabled ? 'cursor-not-allowed opacity-70' : 'cursor-pointer',
        className
      )}
    >
      <span className="relative inline-flex shrink-0">
        <input
          id={id}
          type="checkbox"
          role="switch"
          aria-checked={checked}
          checked={checked}
          disabled={disabled}
          onChange={(o) => onChange(o.target.checked)}
          className="peer sr-only"
          {...kalan}
        />
        {/* ray */}
        <span
          aria-hidden="true"
          className={cn(
            'block h-5 w-8 rounded-full border transition-colors duration-150',
            'peer-focus-visible:shadow-[var(--focus-ring)]',
            checked
              ? 'border-[var(--accent)] bg-[var(--accent)]'
              : 'border-[var(--line-strong)] bg-[var(--surface)]'
          )}
        />
        {/* topuz: 16px, rayın içinde 2px pay; seçiliyken 12px sağa */}
        <span
          aria-hidden="true"
          className={cn(
            'absolute top-0.5 left-0.5 block size-4 rounded-full bg-[var(--surface)] shadow-[var(--shadow-menu)] transition-transform duration-150',
            checked ? 'translate-x-3 bg-[var(--accent-ink)]' : 'translate-x-0 bg-[var(--ink-faint)]'
          )}
        />
      </span>
      {etiket && <span className="text-sm text-[var(--ink)]">{etiket}</span>}
    </label>
  );
}
